import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

// items: [{ name, to? }, ...]
export default function Breadcrumbs({ items = [] }) {
  if (!items.length) return null;
  return (
    <nav
      data-testid="breadcrumbs"
      className="flex items-center flex-wrap gap-1 text-[10px] tracking-editorial-sm uppercase"
      style={{ color: "var(--ink-3)" }}
    >
      {items.map((it, i) => {
        const last = i === items.length - 1;
        return (
          <React.Fragment key={i}>
            {it.to && !last ? (
              <Link to={it.to} className="hover:underline underline-offset-4">{it.name}</Link>
            ) : (
              <span style={{ color: last ? "var(--ink)" : undefined }}>{it.name}</span>
            )}
            {!last && <ChevronRight size={11} strokeWidth={1.5} className="opacity-60" />}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
